import {addEvent} from '../add-event'

export function clickAdminSignInEvent(): boolean {
    return addEvent('loginPageClickAdminSignIn', {})
}
